/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React, { useState, useEffect, ReactElement } from "react";
import axios from "axios";
import DOMPurify from "dompurify";
import ApprovalRequestForm from "./components/approvalRequestForm";
import ClaimLimitBanner from "./components/claimLimitBanner"
import setUpAxios from "../../helperFunctions/helperFunctions";

interface ApprovalRequestClaimProps {
    award_id: string;
    award_invalid: boolean;
}

const ApprovalRequestClaim = ({
    award_id,
    award_invalid,
}: ApprovalRequestClaimProps): ReactElement => {
    const [award, setAward] = useState(null);

    useEffect(() => {
        setUpAxios();
        const fetchData = async (): Promise<void> => {
            const { data } = await axios("/awards/approval_requests/new", {
                params: {
                    award_id,
                },
            });

            setAward(data);
        };

        fetchData();
    }, [award_id]);
    return (
        <div>
            <h3 className="claimable-award-title">{award?.award_name}</h3>
            <div className="logo-and-caption">
                <div className="claim-modal-logo">
                    <span
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(award?.award_avatar),
                        }}
                    />
                </div>
                <div className="caption">{award?.award.description}</div>
            </div>
            <hr />
            {award?.claim_limit_data.claim_limited && <ClaimLimitBanner {...award?.claim_limit_data} />}
            <ApprovalRequestForm
                giverID={award?.award.giver_id}
                awardID={award?.award._id}
                awardInvalid={award_invalid}
                claimableByUser={!award?.claim_limit_data.claim_limited || award?.claim_limit_data.claimable_by_user}
            />
        </div >
    );
};

export default ApprovalRequestClaim;
